import api from '../../services/api';
import BaseService from '../BaseService';

class ProgramaFaqService extends BaseService {
    constructor() {
        super('/programas/faq/');
    }

    getAll(paramsOrProgramaId, page = 1, filters = {}) {
        if (typeof paramsOrProgramaId !== 'object' || paramsOrProgramaId === null) {
            const params = { page, ...filters };
            if (paramsOrProgramaId) {
                params.programa_id = paramsOrProgramaId;
            }
            return super.getAll(params);
        }
        return super.getAll(paramsOrProgramaId);
    }

    registrarDuvida(data) {
        return api.post(`${this.resource}registrar-duvida/`, data);
    }
}

export default new ProgramaFaqService();
